
// NicheWallet.js

import React from 'react';
import '../../styles/products/NicheWallet.css';

import { LuWalletCards } from "react-icons/lu";
import { BsQrCodeScan } from "react-icons/bs";
import { MdOutlineEditNote } from "react-icons/md";
import nichewalletFrame from '../../images/products/nichewallet/nicheWalletFrame.png';

import Logo from '../design/Logo';
import TitleField from '../text/TitleField';
import TextField from '../text/TextField';
import FeatureCard from '../design/FeatureCard';

import { useMediaQuery } from '../../hooks/useMediaQuery';

const product = {
    name: 'NicheWallet',
    overview: 'NicheWallet is a cardholder wallet app that securely stores all your RA-issued cards, providing easy access and management of your digital credentials.',
    orientation: 'portrait',
    features: [
        {
            title: 'Card Storage',
            description: 'Store and manage all your RA-issued cards in one place.',
            icon: LuWalletCards,
        },
        {
            title: 'QR Access',
            description: 'Access RA services through secure QR code scanning',
            icon: BsQrCodeScan,
        },
        {
            title: 'Edit Notes',
            description: 'Access and edit information on your cards accross RAs',
            icon: MdOutlineEditNote,
        },
    ],
};

const NicheWallet = () => {
    // Mobile and the "iPad display" range (see NicheWallet.css) both show
    // feature cards in landscape style (icon beside text) regardless of
    // this product's own desktop orientation — the iPad range further
    // picks up the ipad-tuned landscape design from FeatureCard.css.
    const isMobileViewport = useMediaQuery('(max-width: 767px)');
    const isIpadCardViewport = useMediaQuery('(min-width: 768px) and (max-width: 912px)');
    const featureOrientation = (isMobileViewport || isIpadCardViewport) ? 'landscape' : product.orientation;

    return (
        <section id="nichewallet" className="product-showcase-container product-nichewallet-showcase-container">

            <div className="product-showcase-info-container product-nichewallet-showcase-info-container">
                <div className="product-showcase-logo-container product-nichewallet-showcase-logo-container">
                    <Logo variant="full" size="small" mode="light" />
                </div>
                <div className="product-showcase-title-container product-nichewallet-showcase-title-container">
                    <TitleField title={product.name} level={2} bold={true} fontSize='2.4rem' />
                </div>
                <div className="product-showcase-overview-container product-nichewallet-showcase-overview-container">
                    <TextField text={product.overview} fontColor="#666666" fontSize='1.1rem' />
                </div>
                <div className="product-feature-container product-nichewallet-feature-container">
                    <FeatureCard title={product.features[0].title} description={product.features[0].description} icon={product.features[0].icon} orientation={featureOrientation} />
                    <FeatureCard title={product.features[1].title} description={product.features[1].description} icon={product.features[1].icon} orientation={featureOrientation} />
                    <FeatureCard title={product.features[2].title} description={product.features[2].description} icon={product.features[2].icon} orientation={featureOrientation} />
                </div>
            </div>
            <div className="product-visual-container product-nichewallet-visual-container">
                <div className="product-visual product-nichewallet-visual">
                    <img 
                        className="product-visual-image product-nichewallet-visual-image" 
                        src={nichewalletFrame} 
                        alt={`${product.name} preview`}
                        draggable={false} />
                </div>
            </div>
        </section>
    );
};

export default NicheWallet;
